/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percent Solution Calculator`)
};

const es_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solución Porcentual`)
};

const de_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozentlösungsrechner`)
};

const nl_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procentuele oplossingscalculator`)
};

const fr_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de solution en pourcentage`)
};

const it_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di soluzioni percentuali`)
};

const pt_br2_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solução Percentual`)
};

const pt_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Solução Percentual`)
};

const ja_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント溶液計算ツール`)
};

const zh_pctsol_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比溶液计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_tool_name", locale)
	if (locale === "en") return en_pctsol_tool_name(inputs)
	if (locale === "es") return es_pctsol_tool_name(inputs)
	if (locale === "de") return de_pctsol_tool_name(inputs)
	if (locale === "nl") return nl_pctsol_tool_name(inputs)
	if (locale === "fr") return fr_pctsol_tool_name(inputs)
	if (locale === "it") return it_pctsol_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_tool_name(inputs)
	if (locale === "pt") return pt_pctsol_tool_name(inputs)
	if (locale === "ja") return ja_pctsol_tool_name(inputs)
	return zh_pctsol_tool_name(inputs)
};